import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, InputField, FormError, InputError } from '../form';
import { FormGroup, Button } from 'reactstrap';

import { loginSuccess, loginUnload, loadApp } from '../../actions';
import { ResetPassword as ResetPasswordApi } from '../../api'

import { Link } from 'react-router-dom';
import queryString from 'query-string';

const mapStateToProps = state => ({ ...state.login });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({loginSuccess: loginSuccess, loadApp, onUnload: loginUnload}, dispatch);
};


const ResetPasswordForm = ({onSuccess, onFail}) => (
<div className="panel-body">
  <h3 className="text-center">Reset your password</h3>
  
  <Form
    onSubmit={ResetPasswordApi.create}
    onSuccess={onSuccess}
    onFail={this.onFail}
    validate={values => {
      const errors = {};
      return errors;
    }}
    render={({ submitError, handleSubmit, reset, submitting, pristine, values }) => (
  
      <form onSubmit={handleSubmit} noValidate={true}>
      
        <FormGroup className="small text-center">
          Enter your email address below and we&apos;ll send you a link to reset your password.
        </FormGroup>
        
        {submitError && <FormError>{submitError}</FormError>}
        
        <FormGroup>
          <InputField meta={{submitting}} name="email" type="email" placeholder="Your Email" />
        </FormGroup>
        
        <Button
          className="upcase"
          color="primary"
          type="submit"
          block
          disabled={submitting}>
          Reset password
        </Button>
      
      </form>
    )}
  />
</div>
)




const NewPasswordForm = ({onSuccess, onFail, token}) => (
<div className="panel-body">
  <h3 className="text-center">Reset your password</h3>

  <Form
    onSubmit={ResetPasswordApi.update}
    onSuccess={onSuccess}
    onFail={this.onFail}
    initialValues={{reset_password_token: token}}
    validate={values => {
      const errors = {};
      return errors;
    }}
    render={({ submitError, handleSubmit, reset, submitting, pristine, values }) => (

      <form onSubmit={handleSubmit} noValidate={true}>
        {submitError && <FormError>{submitError}</FormError>}
        
        <InputError name="reset_password_token" title="Reset token" />
        
        <FormGroup>
          <InputField meta={{submitting}} name="password" type="password" placeholder="Password" />
        </FormGroup>
      
        <FormGroup>
          <InputField meta={{submitting}} name="password_confirmation" type="password" placeholder="Confirm password" />
        </FormGroup>
        
        <Button
          className="upcase"
          color="primary"
          type="submit"
          block
          disabled={submitting}>
          Reset password
        </Button>
    
      </form>
    )}
  />
</div>
)



const ResetTokenSuccess = () => (
<div className="panel-body">
  <h3 className="text-center">Please check your email</h3>
  
  <FormGroup className="small text-center">
    Instructions to reset your password have been sent to you
  </FormGroup>
</div>
)

const ResetPasswordSuccess = () => (
<div className="panel-body">
  <h3 className="text-center">Password updated successfully</h3>
  
  <FormGroup className="small text-center">
    <Link to="/login" className="btn btn-primary">Sign in</Link>
  </FormGroup>
</div>
)

class ResetPassword extends Component {
  
  constructor (props){
    super(props)
    this.onResetTokenSuccess = this.onResetTokenSuccess.bind(this)
    this.onPasswordSuccess = this.onPasswordSuccess.bind(this)
    
    const params = queryString.parse(props.location.search);
    const { token } = params;
    
    this.state = {
      resetTokenSuccess: false,
      resetPasswordSuccess: false,
      token: token
    }
  }
  
  onResetTokenSuccess () {
    this.setState({resetTokenSuccess: true})
  }
  
  onPasswordSuccess () {
    this.setState({resetPasswordSuccess: true})
  }
  
  render () {
    const { resetTokenSuccess, resetPasswordSuccess, token } = this.state
    return (
      <div className="panel">
        { token 
          ?
            (resetPasswordSuccess ? <ResetPasswordSuccess /> : <NewPasswordForm token={token} onSuccess={this.onPasswordSuccess} />)
          :
            (resetTokenSuccess ? <ResetTokenSuccess /> : <ResetPasswordForm onSuccess={this.onResetTokenSuccess} />)
        }
        
        <div className="panel-footer text-center">
          <Link to="/signup">Don&apos;t have an account? Sign up &rarr;</Link>
        </div>
      </div>
    )
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(ResetPassword);


// WEBPACK FOOTER //
// ./src/components/auth/Reset.js